import './App.css';

import Crossword from '@jaredreisinger/react-crossword';


const data = {
  across: {
    2: {
      clue: 'Exercise we did the most this year',
      answer: 'RUNNING',
      row: 1,
      col: 0,
    },
    6: {
      clue: 'Who\'s super world in Osaka univeral studios',
      answer: 'MARIO',
      row: 2,
      col: 19,
    },
    9: {
      clue: 'An odd food place to find near Kawaguchi',
      answer: 'PATISSERIE',
      row: 4,
      col: 0,
    },
    10: {
      clue: 'Which city we stopped over to on the way to Japan',
      answer: 'HONGKONG',
      row: 5,
      col: 11,
    },
    11: {
      clue: 'Neighbourhood full of maids in Japan',
      answer: 'AKIHABARA',
      row: 6,
      col: 3,
    },
    13: {
      clue: 'Sophisticated concerts of the summer',
      answer: 'PROMS',
      row: 7,
      col: 19,
    },
    14: {
      clue: 'Cream puff I tried for the first time',
      answer: 'BEARDPAPA',
      row: 8,
      col: 1,
    },
    16: {
      clue: 'Where we got dino wings',
      answer: 'MEDSALLEH',
      row: 9,
      col: 13,
    },
    19: {
      clue: 'Something that revealed itself whilst in Japan',
      answer: 'FUJI',
      row: 12,
      col: 4,
    },
    20: {
      clue: 'Sweets your mum got me and how I saved Deepavali',
      answer: 'KAJUKATLI',
      row: 12,
      col: 12,
    },
    23: {
      clue: 'Sourvenir from Singapore',
      answer: 'COASTER',
      row: 14,
      col: 7,
    },
    24: {
      clue: 'District in Osaka we stayed in',
      answer: 'KITAHAMA',
      row: 14,
      col: 16,
    },
    25: {
      clue: 'Where the hotsprings are',
      answer: 'HAKONE',
      row: 15,
      col: 2,
    },
    28: {
      clue: 'Ingredient for Kyoto speciality restuarant',
      answer: 'TOFU',
      row: 17,
      col: 5,
    },
    29: {
      clue: '___ Plaza, where I met your dad in Singapore',
      answer: 'TANG',
      row: 17,
      col: 10,
    },
    32: {
      clue: 'What I didn\'t get you last year',
      answer: 'PEONIES',
      row: 17,
      col: 18,
    },
    34: {
      clue: 'Park named after you in Japan',
      answer: 'YOYOGI',
      row: 18,
      col: 0,
    },
    36: {
      clue: 'They fry everything!',
      answer: 'AIRFRYER',
      row: 20,
      col: 13,
    },
    37: {
      clue: 'Magical school with a great ride in Osaka',
      answer: 'HOGWARTS',
      row: 21,
      col: 0,
    },
    38: {
      clue: 'Where xiaolongbaos are made',
      answer: 'DINTAIFUNG',
      row: 23,
      col: 1,
    }
  },
  down: {
    1: {
      clue: 'What you stressed out about on the shinkansen',
      answer: 'LUGGAGE',
      row: 0,
      col: 1,
    },
    3: {
      clue: 'What we hunted for in Japan',
      answer: 'MATCHA',
      row: 1,
      col: 11,
    },
    4: {
      clue: 'Your best made dessert',
      answer: 'COOKIES',
      row: 1,
      col: 23,
    },
    5: {
      clue: 'Beep beep the red ___',
      answer: 'ROCKET',
      row: 2,
      col: 15,
    },
    7: {
      clue: 'City where studio ghibli museum is in',
      answer: 'MITAKA',
      row: 3,
      col: 3,
    },
    8: {
      clue: 'My best made dessert',
      answer: 'TANGYUAN',
      row: 3,
      col: 17,
    },
    12: {
      clue: 'Where we went to go see the cherry blossoms',
      answer: 'GREENWICH',
      row: 6,
      col: 20,
    },
    15: {
      clue: 'District in Tokyo we stayed in',
      answer: 'AKASAKA',
      row: 8,
      col: 9,
    },
    17: {
      clue: 'Title of a little boy who lived on a rock',
      answer: 'PRINCE',
      row: 10,
      col: 7,
    },
    18: {
      clue: 'Your gift this year',
      answer: 'EARRINGS',
      row: 11,
      col: 13,
    },
    21: {
      clue: 'Ingredient for pressurised food bomb',
      answer: 'PUMPKIN',
      row: 12,
      col: 22,
    },
    22: {
      clue: 'Chewy ball on a stick',
      answer: 'DANGO',
      row: 14,
      col: 3,
    },
    26: {
      clue: 'City of the wedding we went to',
      answer: 'LUTON',
      row: 16,
      col: 8,
    },
    27: {
      clue: 'Fuzzy creature we saw on my birthday',
      answer: 'TOTORO',
      row: 16,
      col: 20,
    },
    30: {
      clue: 'School on your TV',
      answer: 'ABBOTT',
      row: 17,
      col: 11,
    },
    31: {
      clue: 'Amount of times we went to see PROMS',
      answer: 'FOUR',
      row: 17,
      col: 15,
    },
    33: {
      clue: 'Giggling sea creature',
      answer: 'SQUID',
      row: 17,
      col: 24,
    },
    35: {
      clue: 'City we went to on our first road trip out of London',
      answer: 'OXFORD',
      row: 18,
      col: 1,
    }
  },
}

function CrosswordPage() {
 return(
  <Crossword data={data} />
 );
}

export default CrosswordPage;
